import { render, staticRenderFns } from "./HistoryDetailModal.vue?vue&type=template&id=365a5ee6&scoped=true"
import script from "./HistoryDetailModal.vue?vue&type=script&lang=js"
export * from "./HistoryDetailModal.vue?vue&type=script&lang=js"
import style0 from "./HistoryDetailModal.vue?vue&type=style&index=0&id=365a5ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365a5ee6",
  null
  
)

export default component.exports